import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { H2, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from "../../../../../../../../data-layer.js";
import { seedShippingForm } from "../../../../../../../../StepShipping/mappers/StepShipping/mappers/seed-shipping-form.js";
import { formStatesToValues } from "../../../../../../../utils/LoginExpressCheckout/utils/form-state-to-values.js";
import { isFormDataValid } from "../../../../../../../utils/LoginExpressCheckout/utils/validate-form-data.js";
import { useLoggedInCheckout } from "../../../../../../../context/LoginExpressCheckout/context/context.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { useBaseSummarySlot } from "../../../../../../../../slots/summaries/slots/summaries/summary-context.js";
import { useFormSlotWithoutRedux } from "../../../../../../../../slots/forms/slots/forms/form-context.js";
const ContactDetailsSummary = ({
  contactDetails,
  onSubmit,
  isOrderDetailsValid,
  isFailedToFetchUserData = false
}) => {
  const { getLabel } = useIntl();
  const { shippingFormFields, formFieldsMap } = useCheckoutSettings();
  const { isUserLoggedIn } = useLoggedInCheckout();
  const filledFormData = shippingFormFields?.contactDetails && contactDetails && seedShippingForm(shippingFormFields?.contactDetails, contactDetails);
  const [contactDetailsState, setContactDetailsState] = React.useState();
  const labels = {
    title: getLabel("checkout.contact.title"),
    save: getLabel("common.actions.save")
  };
  const { Slots } = useBaseSummarySlot();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleSubmit = React.useCallback(
    (contactDetailsFormState) => {
      if (contactDetailsFormState?.formValid) {
        const updatedContactDetails = contactDetailsState && formStatesToValues(contactDetailsFormState.formState);
        updatedContactDetails && onSubmit?.({ contactDetails: updatedContactDetails });
        setIsModalOpen(false);
      }
    },
    [contactDetailsState, onSubmit]
  );
  const isContactDetailsFormComplete = React.useMemo(() => {
    if (formFieldsMap?.contactDetails?.length && !contactDetails) {
      return false;
    } else {
      return formFieldsMap?.contactDetails ? isFormDataValid(formFieldsMap?.contactDetails, contactDetails) ?? false : false;
    }
  }, [contactDetails, formFieldsMap?.contactDetails]);
  const onEditHandler = React.useCallback(() => {
    pushLoginExpressEditUserDetailsClickEventToDataLayer({
      editType: isContactDetailsFormComplete ? "edit_contact_details" : "add_contact_details_alert",
      isLoggedIn: isUserLoggedIn
    });
    setIsModalOpen(true);
  }, [isContactDetailsFormComplete, isUserLoggedIn]);
  const { contactDetails: contactDetailsForm } = useFormSlotWithoutRedux({
    formInitialData: filledFormData?.formData ? { contactDetails: filledFormData?.formData } : {},
    onChange: setContactDetailsState,
    disableFields: !isFailedToFetchUserData && contactDetails && (!contactDetails?.email || contactDetails?.email !== "") ? ["email"] : [],
    onSubmit: handleSubmit,
    onCancel: () => setIsModalOpen(false),
    className: "login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height"
  });
  if (!Slots.contactDetails) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true,
      className: "login-express-checkout__form-modal"
    },
    /* @__PURE__ */ React.createElement(H2, { variant: "body-head" }, labels.title),
    /* @__PURE__ */ React.createElement(React.Fragment, null, contactDetailsForm)
  ), /* @__PURE__ */ React.createElement(
    Slots.contactDetails,
    {
      actions: {
        onEdit: onEditHandler
      },
      values: contactDetails,
      errorNotification: !isContactDetailsFormComplete ? /* @__PURE__ */ React.createElement(
        Alert,
        {
          role: isOrderDetailsValid ? "status" : "alert",
          className: "alert-m-default ",
          variant: isOrderDetailsValid ? "info" : "error",
          title: getLabel("checkout.contact.incomplete.title")
        },
        getLabel("checkout.information.incomplete.message")
      ) : null
    }
  ));
};
export {
  ContactDetailsSummary
};
//# sourceMappingURL=ContactDetailsSummary.js.map
